import React, { useEffect, useRef, memo } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { WithLoadingSpinner } from "@components/common";
import { ChartWrapper } from "../common";
import { useChartOptions } from "./useChartOptions";
import { ProgressionBarSeries } from "./types";

type Props = {
  chartData?: ProgressionBarSeries[];
  width?: number;
  height?: number;
  isLoading?: boolean;
};

export const ProgressionBarChart = memo(
  ({ chartData, height, isLoading }: Props) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const finishedAnimating =
      chartComponentRef?.current?.chart.series[0]?.finishedAnimating;

    const chartOptions = useChartOptions(chartData, height);

    useEffect(() => {
      if (!finishedAnimating) return;
      chartComponentRef.current?.chart?.reflow();
    }, [chartOptions, finishedAnimating]);

    return (
      <WithLoadingSpinner isLoading={Boolean(isLoading)}>
        {!isLoading && (
          <ChartWrapper>
            <HighchartsReact
              highcharts={Highcharts}
              ref={chartComponentRef}
              options={chartOptions}
              isLoading={Boolean(isLoading)}
            />
          </ChartWrapper>
        )}
      </WithLoadingSpinner>
    );
  }
);
